// Per-run budget for untruncated step responses written to the workflow run history
// when a company has the admin-only "Capture Full Run Logs" setting enabled. Once a
// run's captured bytes exceed this, later steps fall back to truncated history writes.
export const MAX_WORKFLOW_LOG_CAPTURE_BYTES = 50 * 1024 * 1024;
